import { render, staticRenderFns } from "./PostFeed.vue?vue&type=template&id=fbe46ec8&scoped=true&"
import script from "./PostFeed.vue?vue&type=script&lang=js&"
export * from "./PostFeed.vue?vue&type=script&lang=js&"
import style0 from "./PostFeed.vue?vue&type=style&index=0&id=fbe46ec8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe46ec8",
  null
  
)

export default component.exports